<template>
  <div class="modal-popup-news">
    <div class="container-lg">
      <div>
        <div v-if="PageContent.list.length == 0" class="d-flex align-items-center justify-content-center text-center p-3">
          <div>
              <img src="../../../assets/article-empty.svg" style="height:10em;"/>
              <h4 class="mb-3">No articles yet</h4>
             
            </div>
      
      </div>
        <div class="row" v-if="PageContent.list.length != 0">
          <div class="col-12 col-md-12 col-12">
            
             <h1 class="modal-popup-title"> {{ MarketRecap.title }}</h1> 
              <div >
                <p class="text-muted" >{{FormatDate(MarketRecap.date)}}</p>
            </div>
            <div  v-for="(item, index) in MarketRecap.templates" :key="index">
           
            
            <div  v-if="item.contentType == 'title'">
                <h1 class="modal-popup-title" v-html="item.content"></h1>d `2`
              </div>

              <div  v-if="item.contentType == 'string'" class="content-string">
                <p class="text-muted" v-html="item.content"></p>
              </div>
             
              <div v-if="item.contentType == 'image'" class="image-umbraco">
                <b-img class="img-thumbnail" :src="'data:image/jpeg;base64,' + item.content"  fluid-grow alt="Fluid-grow image"></b-img>
              </div>
              <div class="table table-umbraco" v-if="item.contentType == 'table'">
                <p v-html="item.content"></p>
              </div>
                 <div  v-if="item.contentType == 'link'" class="content-string">
                <p class="text-muted" v-html="item.content"></p>
              </div>
              
            </div>
     
            <div class="modal-img-logo">
              <img src="/img/ResearchLogo.3aba6335.svg">
            </div>
          
            <div class="d-flex justify-content-center mt-5">
              <b-pagination
                size="lg"
                v-model="currentPage"
                :total-rows="PageContent.list.length"
                :per-page="perPage"
                v-if="PageContent.list.length > perPage"
              ></b-pagination>
            </div>
          </div>
        </div>
        <!-- <Disclaimer /> -->
      </div>
    </div>
    
  </div>
</template>


<script>
// import Disclaimer from "../ReportsPages/Disclaimer";
import moment from "moment";
import { mapState } from "vuex";
export default {
  components: {
    // Disclaimer,
  },
  data() {
    return {
      perPage: 1,
      currentPage: 1,
    };
  },
  computed: {
    ...mapState({
      PageContent: (state) => state.philstocksResearch.marketRecap,
    }),
      "MarketRecap": function () {
      return this.PageContent.list[this.currentPage - 1];
    },
  },

  async mounted() {
    this.$store.dispatch("philstocksResearch/GetLatestMarketRecapContent");
  },
  methods: {

     GoogleAnalytics() {
      this.$gtag.event("MarketRecap", { method: "Google" });
    },
      FormatDate(date) {
      var result = "";
      if (date == "0001-01-01T00:00:00") {
        result = "--";
      } else {
        result = moment(date).format("MMMM DD, YYYY");
      }
      return result;
    },
  },
};
</script>

<style>
</style>